import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BackButtonStoreStyleComponent } from './back-button-store-style/back-button-store-style.component';
import { ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatCardModule } from '@angular/material/card';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { CrudModule } from '../crud/crud.module';
import { MatExpansionModule } from '@angular/material/expansion';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { MatSliderModule } from '@angular/material/slider';
import { InternalNavigationComponent } from './internal-navigation/internal-navigation.component';



@NgModule({
	imports: [
		CommonModule,
		ReactiveFormsModule,
		MatInputModule,
		MatCardModule,
		MatButtonToggleModule,
		CrudModule,
		MatExpansionModule,
		MatSliderModule,
		ScrollingModule
	],
	providers: [],
	declarations: [ BackButtonStoreStyleComponent, InternalNavigationComponent],
	exports: [ BackButtonStoreStyleComponent, InternalNavigationComponent]
})
export class NavigationModule { }
